import { render } from "./OverviewMap.vue?vue&type=template&id=52d98eb0"
import script from "./OverviewMap.vue?vue&type=script&lang=js"
export * from "./OverviewMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__